// extracted by mini-css-extract-plugin
module.exports = {"component":"page-appear-effect_component__32RTF","top":"page-appear-effect_top__2bhN4","down":"page-appear-effect_down__H-rit","isLoaded":"page-appear-effect_isLoaded__3UQe3"};